export const normSlug = (slug: string | undefined) =>
{
	return ("" + slug).trim().replace(/[^a-z0-9-]/gi, '-').toLowerCase();
}